import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '@coin-depo-core/storage';

@Injectable({
  providedIn: 'root',
})
export class UserTypeService {
  private userType$ = new BehaviorSubject<'Individual' | 'Business'>(
    this.storage.get('user_type', 'Individual')
  );
  cachedUserType$ = this.userType$.asObservable();

  constructor(private storage: StorageService) {}

  userTypeSnapshot() {
    return this.userType$.value;
  }

  setUserType(userType: 'Individual' | 'Business') {
    this.userType$.next(userType);
    this.storage.set('user_type', userType);
  }
}
